import React from "react";

const TheHeader = () => {
  return (
    <>
      <header className="mainHeader">
        <div className="logo">
          <img src="/inCar_logo.jpg" alt="logo" width="150px" />
        </div>
      </header>
    </>
  );
};

export default TheHeader;
